import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { get, set } from '@totalsoft/change-tracking-react';
import CancelIcon from '@mui/icons-material/Cancel';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { IconButton, TextField } from '@totalsoft/rocket-ui';

export const UserAgendaComponent = ({ itemLens, deleteItem, validationInfo }) => {
  return (
    <TableRow>
      <TableCell>
        <TextField fullWidth value={(itemLens.contactName |> get) || ''} onChange={itemLens.contactName |> set} />
      </TableCell>
      <TableCell>
        <TextField
          fullWidth
          value={(itemLens.email |> get) || ''}
          onChange={itemLens.email |> set}
          error={!isValid(validationInfo.email)}
          helperText={getErrors(validationInfo.email)}
        />
      </TableCell>
      <TableCell align='right'>
        <IconButton id='contactMode_deleteBtn' color='primary' variant='text' size='small' onClick={() => deleteItem(itemLens |> get)}>
          <CancelIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

UserAgendaComponent.propTypes = {
  itemLens: PropTypes.object.isRequired,
  deleteItem: PropTypes.func.isRequired,
  validationInfo: PropTypes.object.isRequired
};

export default UserAgendaComponent;
